/*
 * @Author: pengyong
 * @Date: 2020-11-11 22:20:31
 * @LastEditors: awu
 * @LastEditTime: 2020-12-05 21:59:48
 * @Description: 展区接口定义
 * @FilePath: /exhibit/src/api/exhibition.js
 */
import axios from "@/utils/axios.js";
import { BASE_URL } from "./config";
//获取展会
export function getExhibition(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v2/web/exhibition`, params);
}
//获取展会详情
export function getNewExhibitionDetali({ id, params }) {
    return axios.$get(`${BASE_URL}/exhibition/api/v2/web/exhibition/${id}`, params);
}
// 获取参展商列表
export function getExhibitor(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/web/exhibitor`, params);
}
// 获取直播日程
export function getLiveSchedule(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/live-schedule`, params);
}
// 获取展品列表
export function getExhibitionProduct(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v2/web/exhibition-product`, params);
}
// 获取公司客服Uid
export function getCompanyUid(companyId) {
    return axios.$get(`${BASE_URL}/account/api/v1/company/${companyId}/rtm`);
}
// 获取展台详情
export function getExhibitionDetali({ id, params }) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/web/exhibitor/${id}`, params);
}
// 获取展台视频资源
export function getExhibitionVideo(params) {
    return axios.$get(`${BASE_URL}/pano/api/pano/resourceList`, params);
}
// 收藏视频
export function isCollectVideo(params) {
    return axios.$post(`${BASE_URL}/exhibition/api/v1/purchaser/resource/mark`, params);
}
// 取消视频收藏
export function noCollectVideo(params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v1/purchaser/resource/unmark`, params);
}
// 搜索公司列表
export function getExhibitorList(params) {
    return axios.$get(`${BASE_URL}/exhibition/api/v1/web/exhibitor`, params);
}
// 收藏展品
export function isCollectProduct(params) {
    return axios.$post(`${BASE_URL}/exhibition/api/v1/purchaser/exh_product/mark`, params);
}
//取消展品收藏
export function noCollectProduct(params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v1/purchaser/exh_product/unmark`, params);
}
// 收藏展商
export function isCollectExhibitors(params) {
    return axios.$post(`${BASE_URL}/exhibition/api/v1/purchaser/exh_company/mark`, params);
}
//取消展商收藏
export function noCollectExhibitors(params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v1/purchaser/exh_company/unmark`, params);
}
//展品详情
export function getProductDetail({ id, params }) {
    return axios.$get(`${BASE_URL}/exhibition/api/v2/web/exhibition-product/${id}`, params);
}
//交换名片
export function exchangeCard(params) {
    return axios.$post(`${BASE_URL}/exhibition/api/v1/purchaser/business_card/switch_card`, params);
}
// 收藏文件
export function isCollectDoc(params) {
    return axios.$post(`${BASE_URL}/exhibition/api/v1/purchaser/com_doc/mark`, params);
}
// 取消文件收藏
export function noCollectDoc(params) {
    return axios.$delete(`${BASE_URL}/exhibition/api/v1/purchaser/com_doc/unmark`, params);
}
// 获取视频截图
export function getSnapshot(id) {
    return axios.$get(`${BASE_URL}/storage/api/v1/resource/snapshot/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/exhibition.js